import styles from './ReconnectingBanner.module.css';

// Связь с комнатой прервалась: плашка всегда на виду, где бы ни был скролл
export function ReconnectingBanner() {
  return <p className={styles.banner}>Связь прервалась, восстанавливаем...</p>;
}
